let localStorageService: Storage | null = null;

// when localStorage is disabled in browser, window.localStorage access raises error
try {
  localStorageService = window.localStorage;
} catch (e) {}

export { localStorageService };
